import { ICategory } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectCategories = (state: IApplicationState): ICategory[] => {
  return state.promosPage.categories;
};
